module.exports = __webpack_public_path__ + "img/movilidad.afa68754.svg";